<template>
  <div class="blur" :style="showBanner? 
  {
    marginBottom: '-77px',
    height: `calc(${getSafeAreaTop()}px + 37.9vw)`, 
    maxHeight: `calc(${getSafeAreaTop()}px + 227px)`
  } : {
    marginBottom: '-27px',
    height: `calc(${getSafeAreaTop()}px + ${mode === 2 ? 120 : 88}px)`
  }">
    <Banner v-if="showBanner" :data = "bannerList" />
  </div>
  <div class="background" :style="{paddingTop: getSafeAreaTop() + 'px'}">
    <div v-if="!showBanner" class="left" :style="{marginTop: getSafeAreaTop() + 'px'}">
      <div v-if="mode === 1 || mode === 2" class="logo">
        <img :src="logo" alt="" />
      </div>
      <div class="label" v-if="mode == 0 || mode === 2" :class="showExtra"  @click="switchOrg">
        <span class="name" >{{ userName }}&nbsp;|&nbsp;</span>
        <span class="company">
          {{ orgName }}
        </span>
        <svg  v-if="canSwitchOrg" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink: 0;margin-left: 5px;justify-content: center;align-self: center;">
          <path d="M1.37548 13.7594C1.07098 14.0701 0.565703 14.0814 0.246902 13.7847C-0.0473766 13.5108 -0.0798979 13.0702 0.156332 12.7598L0.220992 12.685L5.79591 6.99844L0.249559 1.3136C-0.0307865 1.02619 -0.0414104 0.584606 0.209947 0.285617L0.27824 0.214012C0.573208 -0.0591507 1.02641 -0.0695019 1.33326 0.175415L1.40675 0.241958L8 7.00132L1.37548 13.7594Z" fill="white"/>
        </svg>
      </div>
    </div>
    <div class="msg" :style="{marginTop: getSafeAreaTop() + 'px'}">
      <div class="tutu">
        <!-- <img src="https://static.service.z-trip.cn/resources/pic/1253481707158-848704c0-97cb-4e3e-90d1-652dfae1bc29.webp" alt=""> -->
      </div>
      <div
        class="msg-icon"
        :class="{ 'red-dots': unReadMessageNum }"
        @click="pushMsg"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="29" viewBox="0 0 30 29" fill="none">
          <path d="M2.5 3.75H27.5V22.5H18.125L15 25.625L11.875 22.5H2.5V3.75Z" stroke="white" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.375 13.125H15.6266" stroke="white" stroke-width="2.08333" stroke-linecap="round"/>
          <path d="M20.6256 13.125H21.8749" stroke="white" stroke-width="2.08333" stroke-linecap="round"/>
          <path d="M8.12561 13.125H9.37492" stroke="white" stroke-width="2.08333" stroke-linecap="round"/>
        </svg>
      </div>  
    </div>
  </div>
  <Plugin
      v-if="canSwitchOrg"
      from="m/platform/plugin/common"
      name="change-org"
      :emit="{
        onReady: registerDialog
      }"
    />
</template>
<script setup>
import { usePluginReadyEmit } from 'app-core'
import { getSafeAreaTop } from '@/adapter/safeArea'
import { onMounted, ref } from 'vue'
import Banner from './Banner.vue'
const logo = ref('')
const showBanner = ref(false)
const bannerList = ref([])
const userName = ref('')
const mode = ref(-1)
const orgName = ref('')
const canSwitchOrg = ref(false)
const [showDialog, registerDialog] = usePluginReadyEmit()

const getTopInfo = async () => {
  try {
    const res = await window.$httpUtil.instance.get('/api/pp/common/platform/home/homeTop')
    const resData = res?.data?.data
    if (res?.data?.code == 0 && resData) {
      mode.value = resData.headerMode ?? -1 // 头部模式，0:仅文字、1:仅LOGO、2:LOGO+名称；
      const isEn = resData.language === 'en-US'
      const userNameRes = isEn ? (resData.lastName || '') + ' ' + (resData.firstName || '')  : (resData.userName || '')
      const orgNameRes = isEn ? (resData.orgNameEn || '') : (resData.orgName || '')
      canSwitchOrg.value = !!resData.canSwitchOrg
      switch (mode.value) {
        case 0:
          userName.value = userNameRes
          orgName.value = orgNameRes
          break
        case 1:
          logo.value = resData.logoUrl || ''
          break
        case 2:
          logo.value = resData.logoUrl || ''
          userName.value = userNameRes
          orgName.value = orgNameRes
          break
      }
    }
  } catch (e) {
    console.error('getTopInfo error:', e)
  }
}
const getBanner =  async () => {
    const res = await window.$httpUtil.instance.get('/platform/configAd/headConfig.json')
  bannerList.value = (res.data.data.banner || []).map(item => {
      return {
      src: item.imageUrl,
      url: item.clickUrl
      }
    })
    showBanner.value = bannerList.value.length > 0
}
onMounted(() => {
  getTopInfo()
  getBanner()
})
const switchOrg = async () => {
  showDialog()
}
const props = defineProps({
  unReadMessageNum: {
    type: [String, Number],
    default: ''
  }
})

const pushMsg = () => {
  $jump.goLocPage('/common/tasks')
}
</script>
<style lang="less" scoped>
  .msg {
    top: 19px;
    pointer-events:auto;
    right: 14px;
    position: absolute;
    width: 86px;
    z-index: 0;
    align-items: flex-start;
    height:100%;  
    display: flex;
    justify-content: space-between;
    .msg-icon{
      margin-top: -3px;
      width: 30px;
      height:30px;
      &.red-dots {
        position: relative;
        &::after {
          position: absolute;
          content: '';
          top: -2px;
          right: -2px;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: red;
        }
      }
    }
    .tutu{
      width: 30px;
      height: 30px;
    }
  }
  .left {
    position: absolute;
    top: 19px;
    pointer-events: all;
    z-index: 2;
    display: flex;
    gap:12px;
    width: calc(100vw - 120px);
    left: 16px;
    overflow: hidden;
    justify-content: flex-start;
    flex-flow: column;
    > div {
      font-weight: 600;
      text-shadow: 0 0 2px rgba(0,0,0,0.5);
      color: var(--main-head-text-color);
    }
    
  }
  .blur{
    background-color: var(--main-head-bg);
    position: relative;
    z-index: 0;
    &::after {
      content:'';
      display: block;
      height: 112px;
      position: absolute;
      bottom: -50px;
      left: 0;
      right: 0;
      pointer-events: none;  
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0, #F5F6F9 50%);
      z-index: 1;
    }
  }
  .background{
    pointer-events:none;
    // z-index: 1000;
    position:absolute;
    top: 0;
    left: 0;
    right: 0;
    // background-color: var(--main-head-bg);
    // backdrop-filter: blur(2px) saturate(180%);
    // border-bottom: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: 2px;
    height:60px;
    box-sizing: content-box;
  }
  .logo {
    display: flex;
    align-items: center;;
    text-align: left;
    height:30px;
    max-width: 100%;
    img{
      display: block;
      width: auto;
      height: 30px;
    }
  }
  .label {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    height:20px;
    width: 100%;
    .name {
      font-size: 20px;
      flex-shrink: 0;
    }
    .company {
      max-width: 200px;
      font-size: 14px;
      line-height: 20px;
      color: var(--main-head-text-color);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
  }
</style>